export const SET_HRES75U_INDEX_DISP = 'SET_HRES75U_INDEX_DISP'
export const GET_HRES75U_INDEX_DISP = 'GET_HRES75U_INDEX_DISP'
export const SET_HRES75U_DETAIL_DISP = 'SET_HRES75U_DETAIL_DISP'
export const GET_HRES75U_DETAIL_DISP = 'GET_HRES75U_DETAIL_DISP'
export const SET_HRES75U_MAX_ROWSPAN = 'SET_HRES75U_MAX_ROWSPAN'
export const GET_HRES75U_MAX_ROWSPAN = 'GET_HRES75U_MAX_ROWSPAN'
export const SET_HRES75U_COLUMNS = 'SET_HRES75U_COLUMNS'
export const GET_HRES75U_COLUMNS = 'GET_HRES75U_COLUMNS'
export const SET_HRES75U_LABELS = 'SET_HRES75U_LABELS'
export const GET_HRES75U_LABELS = 'GET_HRES75U_LABELS'
export const RECEIVED_HRES75U_COLUMNS_LABELS = 'RECEIVED_HRES75U_COLUMNS_LABELS'
export const SET_HRES75U_INDEX = 'SET_HRES75U_INDEX'
export const GET_HRES75U_INDEX = 'GET_HRES75U_INDEX'
export const RECEIVED_HRES75U_INDEX = 'RECEIVED_HRES75U_INDEX'
export const SET_HRES75U_INDEX_SELECTED = 'SET_HRES75U_INDEX_SELECTED'
export const GET_HRES75U_INDEX_SELECTED = 'GET_HRES75U_INDEX_SELECTED'

export const SET_HRES75U_DETAIL = 'SET_HRES75U_DETAIL'
export const GET_HRES75U_DETAIL = 'GET_HRES75U_DETAIL'
export const RECEIVED_HRES75U_DETAIL = 'RECEIVED_HRES75U_DETAIL'

export const SET_HRES75U_DETAIL_SUBMIT = 'SET_HRES75U_DETAIL_SUBMIT'
export const GET_HRES75U_DETAIL_SUBMIT = 'GET_HRES75U_DETAIL_SUBMIT'
export const RECEIVED_HRES75U_DETAIL_SUBMIT = 'RECEIVED_HRES75U_DETAIL_SUBMIT'

export const TOGGLE_HRES75U_PAGE = 'TOGGLE_HRES75U_PAGE'
export const POST_HRES75U_SEND_APPROVE = 'POST_HRES75U_SEND_APPROVE'




// WEBPACK FOOTER //
// ./src/store/modules/hres75u/mutation-types.js